module.exports = __webpack_public_path__ + "static/media/say@2x.b450ff47.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/on/say@2x.png
// module id = 590
// module chunks = 1